<div class="landing-page-container">
  <div class="landing-page-content">
    <i class="pi pi-check-circle check"></i>
    <div class="title">
      {{ "MESSAGE.THANK_YOU" | translate : locale.language }}
    </div>
    <div class="message">
      {{ "MESSAGE.COMPANY_NOW_REGISTERED" | translate : locale.language }}
    </div>
  </div>
</div>
